import * as React from 'react';
import './assessRiskProfile.style.css';
import { TQuestionData } from '../models/riskQuestion.model';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ERiskPageType } from '../models/riskPageType';

export interface IAssertRisk {
  /* Slide Number: 1, maximumDecline: 2, stockMarketForecast: 3, ageRange: 4, plannedWithdrawal: 5 */
  currentRiskSequence: number;
  /** */
  investmentAmount: number;
  /** */
  riskTolerance: TQuestionData;
  /** */
  timeHorizon: TQuestionData;
  /** */
  investmentPercentage: TQuestionData;
  /** */
  yourRiskProfile: TQuestionData;
}

export interface IAssertRiskProfileState {
  riskSequence: number;
}

export interface IAssertRiskProfileProps {
  /** Next button click event handler */
  onNextButtonClick: (event: any, data: IAssertRisk) => void;
  /** Back button click event handler */
  onBackButtonClick: (event: any, data: IAssertRisk) => void;
  /** Skip button click event handler */
  onSkipButtonClick?: (event: any, data: IAssertRisk) => void;
  /** */
  backButtonText: string;
  /** */
  nextButtonText: string;
  /** */
  skipButtonText: string;
  /** */
  data: IAssertRisk;
}

export class AssertRiskProfileComponent extends React.Component<
  IAssertRiskProfileProps,
  IAssertRiskProfileState
> {
  constructor(props?: IAssertRiskProfileProps, context?: any) {
    super(props, context);
    this.state = {
      riskSequence: this.props.data.currentRiskSequence
        ? this.props.data.currentRiskSequence
        : 1,
    };
  }

  public handleNextClick_riskTolerance(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.riskTolerance = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 2 });
  }

  public handleNextClick_timeHorizon(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.timeHorizon = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 3 });
  }

  public handleNextClick_investmentPercentage(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.investmentPercentage = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 4 });
  }

  public handleNextClick_yourRiskProfile(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.yourRiskProfile = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 5 });
  }

  public handleBackClick_riskTolerance(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.riskTolerance = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 0 });
  }

  public handleBackClick_timeHorizon(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.timeHorizon = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 1 });
  }

  public handleBackClick_investmentPercentage(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.investmentPercentage = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 2 });
  }

  public handleBackClick_yourRiskProfile(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.yourRiskProfile = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 3 });
  }

  public handleSkipClick_riskTolerance(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.riskTolerance = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 2 });
  }

  public handleSkipClick_timeHorizon(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.timeHorizon = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 3 });
  }

  public handleSkipClick_investmentPercentage(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.investmentPercentage = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 4 });
  }

  public handleSkipClick_yourRiskProfile(
    event: any,
    componentData: TQuestionData,
  ): void {
    this.props.data.yourRiskProfile = componentData;
    this.props.data.currentRiskSequence = this.state.riskSequence;
    this.props.onNextButtonClick(event, this.props.data);
    this.setState({ riskSequence: 5 });
  }

  public render() {
    const { riskSequence } = this.state;
    const {
      investmentAmount,
      riskTolerance,
      timeHorizon,
      investmentPercentage,
      yourRiskProfile,
    } = this.props.data;

    return (
      <React.Fragment>
        {(() => {
          switch (riskSequence) {
            case ERiskPageType.RiskTolerance:
              const actionsRiskTolerance = {
                onBackButtonClick: this.handleBackClick_riskTolerance,
                onNextButtonClick: this.handleNextClick_riskTolerance,
                onSkipButtonClick: this.handleSkipClick_riskTolerance,
              };
              return <div>{'Risk Question component renders here'} </div>;

            case ERiskPageType.TimeHorizon:
              const actionsTimeHorizon = {
                onBackButtonClick: this.handleBackClick_timeHorizon,
                onNextButtonClick: this.handleNextClick_timeHorizon,
                onSkipButtonClick: this.handleSkipClick_timeHorizon,
              };
              return <div>{'Risk Question component renders here'} </div>;
            case ERiskPageType.InvestmentPercentage:
              const actionsInvestmentPercentage = {
                onBackButtonClick: this.handleBackClick_investmentPercentage,
                onNextButtonClick: this.handleNextClick_investmentPercentage,
                onSkipButtonClick: this.handleSkipClick_investmentPercentage,
              };
              return <div>{'Risk Question component renders here'} </div>;
            case ERiskPageType.YourRiskProfile:
              const actionsAgeRange = {
                onBackButtonClick: this.handleBackClick_yourRiskProfile,
                onNextButtonClick: this.handleNextClick_yourRiskProfile,
                onSkipButtonClick: this.handleSkipClick_yourRiskProfile,
              };
          }
        })()}
      </React.Fragment>
    );
  }
}
